import { defineRequest } from "@/lib/fetch-tools";
import { RequestResponse } from "./types";

interface UserInfoResponse {
  id: number;
  username: string;
  phone: string;
  type: number;
  password: string;
  paypassword: string;
  cardzm: string;
  cardfm: string;
  cardsc: string | null;
  rzstatus: number;
  level: number;
  invit1: string;
  invit2: string;
  invit3: string;
  path: string;
  logins: number;
  addip: string;
  addr: string;
  addtime: number;
  endtime: number;
  lgtime: string | null;
  loginip: string | null;
  loginaddr: string | null;
  logintime: string;
  rztime: number;
  rzuptime: string | null;
  status: number;
  txstate: number;
  invit: string;
  stoptime: string | null;
  isAgent: number;
  areaCode: string;
  realName: string;
  area: string | null;
  rztype: string;
  buyOn: number;
  lang: string | null;
  remark: string;
  userType: number;
  jifen: number;
  codeAmount: number;
  depatmentId: number;
  companyId: number;
  userCode: string;
  token: string | null;
  money: number | null;
  winOrLose: number;
  language: string | null;
  twUserKuangji: any | null;
  black: number;
  onlineStatus: any | null;
}

export const apiUserInfo =
  defineRequest <
  RequestResponse<UserInfoResponse>, any>("/api/pc/user/userInfo");
